import { Component, OnInit } from '@angular/core';
import { AdminApiService, AdminCertificate } from '../../../core/services/admin-api.service';

@Component({
    selector: 'app-admin-certificates',
    templateUrl: './admin-certificates.component.html'
})
export class AdminCertificatesComponent implements OnInit {

    certificates: AdminCertificate[] = [];

    model: any = {
        id: 0,
        title: '',
        category: '',
        description: '',
        year: '2026',
        sort: 0,
        status: true
    };

    selectedFile: File | null = null;

    loading = false;
    saving = false;
    errorMessage = '';
    successMessage = '';

    constructor(public adminApi: AdminApiService) { }

    ngOnInit(): void {
        this.getCertificates();
    }

    getCertificates(): void {
        this.loading = true;
        this.errorMessage = '';

        this.adminApi.getCertificates().subscribe(
            (data: AdminCertificate[]) => {
                this.certificates = data || [];
                this.loading = false;
            },
            (error) => {
                console.error(error);
                this.loading = false;
                this.errorMessage = 'Certificates could not be loaded.';
            }
        );
    }

    newCertificate(): void {
        this.model = {
            id: 0,
            title: '',
            category: '',
            description: '',
            year: '2026',
            sort: 0,
            status: true
        };

        this.selectedFile = null;
        this.successMessage = '';
        this.errorMessage = '';
    }

    editCertificate(item: AdminCertificate): void {
        this.model = {
            id: item.id,
            title: item.title,
            category: item.category,
            description: item.description,
            year: item.year,
            sort: item.sort,
            status: item.status
        };

        this.selectedFile = null;
        this.successMessage = '';
        this.errorMessage = '';
    }

    onFileChange(event: Event): void {
        const input = event.target as HTMLInputElement;

        if (input.files && input.files.length > 0) {
            this.selectedFile = input.files[0];
        }
    }

    saveCertificate(): void {
        this.successMessage = '';
        this.errorMessage = '';

        if (!this.model.title || !this.model.category) {
            this.errorMessage = 'Certificate title and category are required.';
            return;
        }

        if (this.model.id === 0 && !this.selectedFile) {
            this.errorMessage = 'PDF file is required for new certificate.';
            return;
        }

        const formData = new FormData();

        formData.append('Id', this.model.id.toString());
        formData.append('Title', this.model.title || '');
        formData.append('Category', this.model.category || '');
        formData.append('Description', this.model.description || '');
        formData.append('Year', this.model.year || '');
        formData.append('Sort', this.model.sort ? this.model.sort.toString() : '0');
        formData.append('Status', this.model.status ? 'true' : 'false');

        if (this.selectedFile) {
            formData.append('File', this.selectedFile);
        }

        this.saving = true;

        this.adminApi.saveCertificate(formData).subscribe(
            () => {
                this.saving = false;
                this.successMessage = 'Certificate saved successfully.';
                this.newCertificate();
                this.getCertificates();
            },
            (error) => {
                console.error(error);
                this.saving = false;
                this.errorMessage = 'Certificate could not be saved.';
            }
        );
    }

    deleteCertificate(id: number): void {
        if (!confirm('Delete this certificate?')) {
            return;
        }

        this.adminApi.deleteCertificate(id).subscribe(
            () => {
                this.getCertificates();
            },
            (error) => {
                console.error(error);
                this.errorMessage = 'Certificate could not be deleted.';
            }
        );
    }
}